/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import dayjs from "dayjs"
import queryString from "query-string"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
  Table,
  ToggleButton,
} from "react-bootstrap"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import ZaikoBihinUkebaraiService from "../../../service/budget/bihinZaikoUkebarai/bihinZaikoUkebaraiService"
import {
  TBihinZaikoUkebaraiListGetReq,
  TBihinZaikoUkebaraiListInfoGetRes,
} from "../../../service/budget/bihinZaikoUkebarai/TBihinZaikoUkebarai"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import { TWijmoComboBox } from "../../../type/wijmoComponents"

import {
  T年ComboBoxItem,
  YearComboBox,
} from "../../../components/ComboBox/YearComboBox"

/**
 * 備品在庫受払表
 * @returns
 */
const BihinZaikoUkebaraiList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用

  //TODO:ページ名称確定必須
  let gridId = "BihinZaikoUkebaraiList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TBihinZaikoUkebaraiListInfoGetRes>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TBihinZaikoUkebaraiListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TBihinZaikoUkebaraiListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    if (currentSearchCondition == null) return

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new ZaikoBihinUkebaraiService().getList(
        currentSearchCondition
      )
      dispatch(setAlerts(res))

      // 検索結果をstateに設定
      setGridData({
        data: createCollectionView(res.data, pageSize),
      })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryの設定
   */
  const queryParse = () => {
    const query: TBihinZaikoUkebaraiListGetReq = queryString.parse(
      location.search
    )
    set年(query.年)
    set年月(query.年月)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TBihinZaikoUkebaraiListGetReq => {
    if (表示切替 === 1) {
      //年間を選択した場合
      return {
        年: 年,
        年月: "",
      }
    }
    //月間を選択した場合
    return {
      年: undefined,
      年月: dayjs(年月).format("YYYYMM"),
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TBihinZaikoUkebaraiListGetReq
  ) => {
    var disp年月 = null
    if (表示切替 === 1) {
      disp年月 = searchCondition.年
      return {
        年: disp年月,
      }
    } else if (表示切替 === 2) {
      const disp年月 = dayjs(searchCondition.年月).format("YYYY/MM")
      debugger
      return {
        年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
      }
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    set年(parseInt(dayjs(eigyobi).format("YYYY")))
    set年月(eigyobi)
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)
  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()
  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  const [年月, set年月] = useState<string | null>()
  const [年, set年] = useState<number>()
  const [年IsLoadEnded, set年IsLoadEnded] = useState<boolean>(false)

  // 年
  const [年ComboBox, set年ComboBox] = useState<TWijmoComboBox<
    number | undefined,
    T年ComboBoxItem
  > | null>(null)

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region comboboxState
  const 表示切替リスト年: Array<{ value: number; name: string }> = [
    { value: 1, name: "年間" },
  ]
  const 表示切替リスト年月: Array<{ value: number; name: string }> = [
    { value: 2, name: "月間" },
  ]
  const [表示切替, set表示切替] = useState<number>(1)
  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `備品在庫受払表`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
    set年(parseInt(dayjs(eigyobi).format("YYYY")))
    set年月(eigyobi)
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      // 検索項目初期化
      set年(parseInt(dayjs(eigyobi).format("YYYY")))
      set年月(eigyobi)

      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  //#endregion
  //#region [components]

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">備品在庫受払表</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-60rem">
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                検索条件
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body>
                  <Form>
                    <Container fluid className="contents-search-main">
                      <Row>
                        <Col>
                          <Table className="search-table">
                            <tbody>
                              <tr>
                                <td valign="middle">
                                  {表示切替リスト年.map((radio, idx, arr) => (
                                    <ToggleButton
                                      key={idx}
                                      id={`radio-${radio.name}`}
                                      type="radio"
                                      variant={"outline-success"}
                                      name="radio"
                                      size="lg"
                                      className="fs-5"
                                      value={radio.value}
                                      checked={表示切替 === radio.value}
                                      onChange={(e) =>
                                        set表示切替(
                                          parseInt(e.currentTarget.value)
                                        )
                                      }>
                                      {radio.name}
                                    </ToggleButton>
                                  ))}
                                </td>
                                <td>
                                  <div className="w-8rem">
                                    <YearComboBox
                                      placeholder="年"
                                      is年度={false}
                                      isLoadEnded={年IsLoadEnded}
                                      isRequired={true}
                                      setIsLoadEnded={set年IsLoadEnded}
                                      selectedValue={年}
                                      setSelectedValue={(v) => {
                                        set年(
                                          v ??
                                            parseInt(
                                              dayjs(eigyobi).format("YYYY")
                                            )
                                        )
                                      }}
                                      isReadOnly={
                                        表示切替 == null || 表示切替 === 2
                                          ? true
                                          : false
                                      }
                                      ComboBox={年ComboBox}
                                      setComboBox={
                                        set年ComboBox
                                      }></YearComboBox>
                                  </div>
                                </td>
                                <div style={{ width: "2rem" }}></div>
                                <td valign="middle">
                                  {表示切替リスト年月.map((radio, idx, arr) => (
                                    <ToggleButton
                                      key={idx}
                                      id={`radio-${radio.name}`}
                                      type="radio"
                                      variant={"outline-success"}
                                      name="radio"
                                      size="lg"
                                      className="fs-5"
                                      value={radio.value}
                                      checked={表示切替 === radio.value}
                                      onChange={(e) =>
                                        set表示切替(
                                          parseInt(e.currentTarget.value)
                                        )
                                      }>
                                      {radio.name}
                                    </ToggleButton>
                                  ))}
                                </td>
                                <td>
                                  <div className="w-8rem">
                                    <MonthInput
                                      id="年月"
                                      value={年月}
                                      setValue={set年月}
                                      defaultValue={eigyobi}
                                      isRequired={true}
                                      placeholder="年月"
                                      isReadOnly={
                                        表示切替 == null || 表示切替 === 1
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <div style={{ width: "2rem" }}></div>
                              </tr>
                              <tr>
                                <td>
                                  <Button
                                    type="submit"
                                    className="ms-auto"
                                    disabled={isSearching}
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      e.preventDefault()
                                      search()
                                    }}>
                                    <FontAwesomeIcon icon={faSearch} />
                                    検索
                                  </Button>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="text-end"></Col>
                      </Row>
                    </Container>
                  </Form>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridConstantProperties={
                    CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS
                  }
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  searchConditionClear={searchConditionClear}
                  gridId={gridId}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}>
                  <wjrGrid.FlexGridColumn
                    binding="備品コード"
                    width={100}
                    header="品CD"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="備品名"
                    width={300}
                    header="品名"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="サイズ"
                    width={100}
                    header="サイズ"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="単位"
                    width={100}
                    header="単位"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="受入数量"
                    width={200}
                    header="受入数量"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="受入金額"
                    width={200}
                    header="受入金額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="払出数量"
                    width={200}
                    header="払出数量"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="払出金額"
                    width={200}
                    header="払出金額"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default BihinZaikoUkebaraiList
